import {
  CLEAR_ALL_TICKET,
  CLEAR_ASSIGNED_TICKET,
  CLEAR_HISTORICAL_TICKET,
  CLEAR_SELECTED_TICKET,
  CLEAR_NOMINATED_TICKET,
  LOCK_CONVERSATION,
  SELECT_ALL_TICKET,
  SELECT_ASSIGNED_TICKET,
  SELECT_HISTORICAL_TICKET,
  SELECT_LIVE_CHAT_TICKET,
  SELECT_NOMINATED_TICKET,
  SELECT_REVIEW_TICKET,
  SELECT_VALIDATION_TICKET,
  UNLOCK_CONVERSATION,
} from 'actions/types';

export const selectedTicketId = (state = '', action) => {
  switch (action.type) {
    case SELECT_REVIEW_TICKET:
    case SELECT_VALIDATION_TICKET:
    case SELECT_NOMINATED_TICKET:
    case SELECT_ASSIGNED_TICKET:
    case SELECT_LIVE_CHAT_TICKET:
    case SELECT_ALL_TICKET:
      return action.selectedTicketId;
    case CLEAR_SELECTED_TICKET:
    case CLEAR_NOMINATED_TICKET:
    case CLEAR_ASSIGNED_TICKET:
    case CLEAR_ALL_TICKET:
      return '';
    default:
      return state;
  }
};

export const selectedHistoricalTicketId = (state = '', action) => {
  switch (action.type) {
    case SELECT_HISTORICAL_TICKET:
      return action.selectedTicketId;
    case CLEAR_HISTORICAL_TICKET:
    case CLEAR_ALL_TICKET:
      return '';
    default:
      return state;
  }
};

export const lockedConversationId = (state = '', action) => {
  switch (action.type) {
    case LOCK_CONVERSATION:
      return action.conversationId;
    case UNLOCK_CONVERSATION:
      return '';
    default:
      return state;
  }
};
